var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVinniBackground(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "143.5433mm",
    height: "165.01271mm",
    viewBox: "0 0 143.5433 165.01271",
    id: "svg145",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs142"
  })), /*#__PURE__*/React.createElement("g", {
    id: "layer1",
    transform: "translate(-51.740365,-85.270091)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path17",
    d: "M 181.20336,199.10811 118.51832,236.28756 54.977445,200.59044 54.121621,127.71388 116.80667,90.534429 180.34754,126.23155 Z",
    style: {
      fill: "#ffffff",
      strokeWidth: 0.26458332
    },
    transform: "matrix(1.0920594,0,0,1.0804145,-4.9824025,-7.2802812)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1125",
    transform: "matrix(0.26458333,0,0,0.26458333,-189.42237,-80.764362)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 1,
      fill: "none",
      fillOpacity: 1,
      stroke: "#000000",
      strokeWidth: 18,
      strokeLinecap: "butt",
      strokeLinejoin: "round",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    id: "path4297-3-7",
    transform: "translate(911.48123,627.53178)",
    d: "M 533.52589,463.25264 271.26294,614.67023 8.9999845,463.25264 8.9999858,160.41746 271.26294,8.9998779 533.52589,160.41747 Z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 18,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeDashoffset: 0,
      strokeOpacity: 1
    },
    d: "m 1182.7442,675.09784 224.663,132.13499",
    id: "path5021-2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 18,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 954.88023,807.23283 -1,264.26797",
    id: "path5023-5"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      fillRule: "evenodd",
      stroke: "#000000",
      strokeWidth: 18,
      strokeLinecap: "butt",
      strokeLinejoin: "miter",
      strokeMiterlimit: 4,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 1182.7442,1203.6358 228.864,-132.135",
    id: "path5025-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVinniBackground);
export default __webpack_public_path__ + "static/media/vinni-background.563c08f1eee77a71380bc097316d63ce.svg";
export { ForwardRef as ReactComponent };